document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-device-gallery-slider').forEach(function (el) {
    const wrap = el.closest('.device-gallery-slider__slider-wrap');
    const wrapper = el.querySelector('.swiper-wrapper');
    const slides = Array.from(el.querySelectorAll('.swiper-slide'));
    if (!slides.length) return;

    const prevBtn = wrap ? wrap.querySelector('.js-device-gallery-prev') : null;
    const nextBtn = wrap ? wrap.querySelector('.js-device-gallery-next') : null;
    const baseCount = parseInt(el.getAttribute('data-base-count') || '0', 10);

    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';

    let current = baseCount || 0;
    let animating = false;

    function gap() {
      return window.innerWidth < 640 ? 30 : 80;
    }

    function setGap() {
      wrapper.style.gap = gap() + 'px';
    }

    function calcTranslate(index) {
      const containerWidth = el.offsetWidth;
      const g = gap();
      let leftSum = 0;
      for (let i = 0; i < index; i++) {
        leftSum += slides[i].offsetWidth + g;
      }
      return containerWidth / 2 - leftSum - slides[index].offsetWidth / 2;
    }

    function goTo(index, animate) {
      current = index;
      wrapper.style.transition = animate ? 'transform 0.45s ease' : 'none';
      wrapper.style.transform = 'translateX(' + calcTranslate(current) + 'px)';
    }

    function step(dir) {
      if (animating) return;
      animating = true;
      goTo(current + dir, true);
      setTimeout(function () {
        if (baseCount > 0) {
          if (current >= baseCount * 2) goTo(current - baseCount, false);
          else if (current < baseCount) goTo(current + baseCount, false);
        }
        animating = false;
      }, 450);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    setGap();
    goTo(current, false);

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setGap();
        goTo(current, false);
      }, 120);
    });
  });
});
